import React, { useEffect } from 'react';

import classes from './ScanIqCustomerPaymentTab.module.scss';
import { CurrentPlanWidget } from './CurrentPlanWidget/CurrentPlanWidget';
import { scanIqCurrentSubscriptionPlanStore } from '../../stores/scanIqCurrentSubscriptionPlanStore';
import { PaymentHistoryTable } from './PaymentHistoryTable/PaymentHistoryTable';
import { PaymentDetailsWidget } from './PaymentDetailsWidget/PaymentDetailsWidget';

type ScanIqCustomerPaymentTabProps = {
  entityId: number;
  customerId: number;
};

const ScanIqCustomerPaymentTab = ({
  entityId,
  customerId,
}: ScanIqCustomerPaymentTabProps) => {
  const { getCurrentSubscriptionPlan, setDefaultValues } =
    scanIqCurrentSubscriptionPlanStore;

  useEffect(() => {
    getCurrentSubscriptionPlan(entityId, customerId);

    return () => {
      setDefaultValues();
    };
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.row}>
        <CurrentPlanWidget />
        <PaymentDetailsWidget />
      </div>
      <PaymentHistoryTable entityId={entityId} customerId={customerId} />
    </div>
  );
};

export { ScanIqCustomerPaymentTab };
